<template>
    <div class="events-index" id="calendar">
        <h2>
            {{ pageTitle }}
            <a
                :href="headLinkHref"
                class="formatLink"
                v-text="headLinkLabel"
            />
        </h2>

        <events-month
            v-if="layout === 'grid'"
            :events="events"
            :event-type="eventType"
            :month="month"
            :earliest="earliest"
            :latest="latest"
            :loading="ajax.loading"
        />
        <events-list
            v-else
            :events="events"
            :event-type="eventType"
            :month="month"
            :earliest="earliest"
            :loading="ajax.loading"
        />
    </div>

</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import OneEvent from './OneEvent';
import EventsList from './EventsList';
import EventsMonth from './EventsMonth';

dayjs.extend(customParseFormat);

export default {
    components: {
        EventsList,
        EventsMonth,
        OneEvent,
    },

    data: function () {
        return {
            events: [],
            // TODO: Get earliest and latest from server
            earliest: dayjs().subtract(2, 'year').format('YYYYMM'),
            latest: dayjs().add(1, 'month').format('YYYYMM'),

            ajax: {
                loading: true,
                message: '',
            }
        }
    },

    computed: {
        monthInUrl() {
            const pathParts = window.location.pathname.split('/');
            const month = pathParts.pop().split('.')[0];
            return /^\d{6}$/.test(month) ? month : null;
        },
        month() {
            return this.monthInUrl ?? dayjs().format('YYYYMM');
        },
        eventType() {
            const pathParts = window.location.pathname.split('/');
            let slug = pathParts.pop();
            if (this.monthInUrl) {
                slug = pathParts.pop();
            }
            if (['food-for-thought', 'coffee-clash', 'social'].includes(slug)) {
                return slug;
            }
            return null;
        },
        layout() {
            const pathParts = window.location.pathname.split('.');
            const layout = pathParts.pop();
            return layout === 'grid' ? 'grid' : '';
        },
        pageTitle() {
            console.debug(this.eventType);
            switch (this.eventType) {
                case 'food-for-thought':
                    return 'Food for Thought';
                case 'coffee-clash':
                    return 'Coffee Clash';
                case 'social':
                    return 'Social';
                default:
                    return 'All events';
            }
        },
        headLinkHref() {
            if (this.eventType) {
                return '/events'
                    + (this.monthInUrl ? ('/' + this.monthInUrl) : '')
                    + '.grid'
                    + '#calendar'
                ;
            }
            return '/' + (this.eventType ?? 'events')
                + '/' + (this.month)
                + (this.layout ? '' : '.grid')
                + '#calendar'
            ;
        },
        headLinkLabel() {
            if (this.eventType) {
                return '(Show calendar of all events)';
            }
            return `(Switch to ${this.layout === 'grid' ? 'list' : 'calendar'} view)`;
        },
    },

    methods: {
        loadData() {
            this.ajax.loading = true;

            const pathParts = window.location.pathname.split('/');
            let tag = pathParts.pop().split('.')[0];
            let dateStart = null;
            let dateEnd = null;
            const thisMonth = dayjs().format('YYYYMM');
            let month = thisMonth;
            if (/^\d{6}$/.test(tag)) {
                month = tag;
                tag = pathParts.pop();
            }
            if (month === thisMonth) {
                dateStart = dayjs().startOf('month');
                dateEnd = dayjs().subtract(1, 'month').add(2, 'year').startOf('month');
            } else {
                dateStart = dayjs(month, 'YYYYMM').startOf('month');
                dateEnd = dayjs(month, 'YYYYMM').endOf('month');
            }


            return axios.get(process.env.MIX_API_BASE_URL + '/api/front/serieables', {
                params: {
                    tag: tag !== 'events' ? tag : null,
                    dateStart: dateStart.format('YYYY-MM-DD'),
                    dateEnd: dateEnd.format('YYYY-MM-DD'),
                },
            })
                .then(response => {
                    // if (!Array.isArray(this.events)) {
                    //     this.events = [];
                    // }
                    this.events.splice(0, this.events.length, ...response.data);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.ajax.loading = false;
                })
            ;
        },
    },

    created() {
        this.loadData();
    },
}
</script>

<style lang="scss">
.events-index {
    .inside-content .main-col .teasers .teaser h3 {
        margin-bottom: 0;
    }
    .serie {
        //display: flex;
        align-items: center;
    }
    .serie .reserve {
        margin-left: 25px;
    }
}
</style>
